import { useEffect, useState } from "react";
import { useReservationList, updateReservation, deleteReservation } from "../firebase/firebase";

import styles from './admin-page-style.module.css'
import { PhoneNumberInput, LocationsSelector } from "../Components/CustomComponents";
import { flagEmpty, notEmpty, toTimestamp } from "..";

export default function ReservationList() {
    const [reservations] = useReservationList();
    const [selectedReservation, setSelectedReservation] = useState();
    const [popUpLocations, setPopUpLocations] = useState();
 
    const toggleSetUpLocations = (locations) => {
        if(popUpLocations == locations)
            setPopUpLocations(undefined);
        else 
            setPopUpLocations(locations);
    }
    const updateSelectedReservation = (reservation) => {
        if(selectedReservation === reservation || (selectedReservation?.id === reservation?.id && reservation?.id !== null))
            setSelectedReservation(undefined);
        else 
            setSelectedReservation(reservation);
    }


    return (
        <div className={styles.panel_item} id={styles.reservations}>
            <div id={styles.resevation_header}>
                <h1>Reservations</h1>
                <button onClick={() => updateSelectedReservation({id: 'new'})}>Create New</button>
            </div>  
            <div style={{display: 'flex', flexDirection: 'row'}}>
                <div className={styles.scroll}>
                    <table>
                        <thead>
                            <tr>
                                <th className={styles.fixed} key='res-name' style={{height: 'auto', background: 'linear-gradient(to right, white 90%, transparent 100%)'}}>Name</th>
                                <th className={styles.spacer_column} key='hidden' style={{height: 'auto'}}></th>
                                <th key='date-time'>Date and Times</th>
                                <th key='reserver'>Reserver</th>
                                <th key='locations'>Locations</th>
                                <th key='actions'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                reservations.length === 0 ?
                                <tr>
                                    <td className={styles.fixed}>No Upcoming Reservations</td>
                                    <td className={styles.spacer_column}></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                :
                                reservations.map((reservation) => <ReservationDetails key={reservation.id} reservation={reservation} setSelectedReservation={updateSelectedReservation} toggleSetUpLocations={toggleSetUpLocations}/>)
                            }
                        </tbody>
                    </table>
                </div>
            </div>  
            
            <ReservationEditor reservation={selectedReservation} setReservation={updateSelectedReservation}/>

            <div className={popUpLocations !== undefined ? styles.location_popup : `${styles.location_popup} ${styles.hidden}`}>
                <h1>Locations</h1>
                <div className={styles.locations}>
                    {popUpLocations?.map((loc) => <p key={Math.random()}>{loc}</p>)}
                </div>
                <button onClick={() => setPopUpLocations(undefined)}>Close</button>
                
            </div>
            <div className={popUpLocations !== undefined ? styles.blocker : `${styles.blocker} ${styles.hidden}`}
                onClick={() => setPopUpLocations(undefined)}/>
        </div>
    )
}

function ReservationDetails({reservation, setSelectedReservation, toggleSetUpLocations}) {
    let dates;

    if(reservation?.start_date !== undefined && reservation?.end_date !== undefined) {
        const startDate = new Date(reservation?.start_date?.seconds * 1000);
        const endDate = new Date(reservation?.end_date?.seconds * 1000);

        if(startDate.getMonth() === endDate.getMonth() && startDate.getDate() === endDate.getDate()) {
            let dateFormatMap = {year: "numeric", month: "numeric", day: "numeric"}
            let timeFormatMap = {hour12: true, hour: 'numeric', minute: '2-digit'}

            dates = <td>{`${startDate.toLocaleString('en-US', dateFormatMap)}`}<br/>
                        {`${startDate.toLocaleString('en-US', timeFormatMap)} - ${endDate.toLocaleString('en-US', timeFormatMap)}`}</td>
        } else {
            let formatMap = {year: "2-digit", month: "numeric", day: "numeric", hour12: true, hour: 'numeric', minute: '2-digit'}
            dates = <td>{`Start: ${startDate.toLocaleString('en-US', formatMap)}`}<br/>
                        {`End: ${endDate.toLocaleString('en-US', formatMap)}`}</td>
        }
    }

    const confirmDelete = () => {
        if(reservation?.id !== undefined && 
            window.confirm(`Are you sure you want to delete\n${reservation?.name}?`)) {
            deleteReservation(reservation?.id)
        }
    }

    return (
        <tr>
            <td className={styles.fixed}>{reservation?.name}</td>
            <td className={styles.spacer_column}></td>
            {dates}
            <td>{reservation?.reserver.name}<br/><a href={`mailto:${reservation?.reserver.email}`}>{reservation?.reserver.email}</a><br/>{reservation?.reserver.phone_number}</td>
            <td>
                <button onClick={() => toggleSetUpLocations(reservation?.locations)}>
                    View {reservation?.locations?.length} Location{reservation?.locations?.length === 1 ? '' : 's'}
                </button>
            </td>
            <td>
                <button onClick={() => setSelectedReservation(reservation)}>Edit</button>
                <button onClick={() => confirmDelete()}>Delete</button>
            </td>

            
        </tr>
    )

}

function ReservationEditor({reservation, setReservation}) {
    const [locations, setLocations] = useState(reservation?.locations ?? []);
    const [startDate, setStartDate] = useState(new Date((reservation?.start_date?.seconds ?? 1) * 1000));
    const [endDate, setEndDate] = useState(new Date((reservation?.end_date?.seconds ?? 1) * 1000));
    const [name, setName] = useState(reservation?.name);

    const [dropDownVisible, setDropdownVisible] = useState(false);

    const [reserverEmail, setReserverEmail] = useState(reservation?.reserver?.email);
    const [reserverPhone, setReserverPhone] = useState(reservation?.reserver?.phone_number);
    const [reserverName, setReserverName] = useState(reservation?.reserver?.name);

    useEffect(() => {
        setLocations(reservation?.locations ?? []);
        setStartDate(new Date((reservation?.start_date?.seconds ?? 1) * 1000));
        setEndDate(new Date((reservation?.end_date?.seconds ?? 1) * 1000));
        setName(reservation?.name);

        setReserverEmail(reservation?.reserver?.email);
        setReserverPhone(reservation?.reserver?.phone_number);
        setReserverName(reservation?.reserver?.name);
    }, [reservation]);

    let initalStartDate = '';
    let initalEndDate = '';
    let initalStartTime = '';
    let initalEndTime = '';

    if(reservation?.start_date != undefined) {
        let date = new Date(reservation?.start_date?.seconds * 1000);

        initalStartDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        initalStartTime = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    }

    if(reservation?.end_date != undefined) {
        let date = new Date(reservation?.end_date?.seconds * 1000);
        initalEndDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
        initalEndTime = `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
    }

    const onStartTimeChanged = (e) => {
        const updated = new Date(startDate);

        if(e.target.type === 'date') {
            const values = e.target.value.split('-');

            updated.setFullYear(Number(values[0]));
            updated.setMonth(Number(values[1]) - 1);
            updated.setDate(Number(values[2]));

            setStartDate(updated);
        } else {
            const values = e.target.value.split(':');
            
            updated.setSeconds(0);
            updated.setHours(Number(values[0]));
            updated.setMinutes(Number(values[1]));

            setStartDate(updated);
        }
    }
    const onEndTimeChanged = (e) => {
        const updated = new Date(endDate);

        if(e.target.type === 'date') {
            const values = e.target.value.split('-');

            updated.setFullYear(Number(values[0]));
            updated.setMonth(Number(values[1]) - 1);
            updated.setDate(Number(values[2]));

            setEndDate(updated);
        } else {
            const values = e.target.value.split(':');

            updated.setSeconds(0);
            updated.setHours(Number(values[0]));
            updated.setMinutes(Number(values[1]));

            setEndDate(updated);
        }
    }
    const onSave = () => {
        let elementID;

        if(name === '' || name === undefined)
            elementID = 'res-name';

        else if (startDate.getFullYear() === 1969)
            elementID = 'res-start';
        else if (startDate.getSeconds() === 1)
            elementID = 'res-start-t';
        else if (endDate.getFullYear() === 1969)
            elementID = 'res-end';        
        else if (endDate.getSeconds() === 1)
            elementID = 'res-end-t';

        else if (reserverName === '' || reserverName === undefined)
                    elementID = 'res-rname';
        else if (reserverEmail === '' || reserverEmail === undefined)
            elementID = 'res-remail';
        
        if(elementID != null)
            flagEmpty(document.getElementById(elementID));
        else {
            const updated = {
                name: name,
                start_date: toTimestamp(startDate),
                end_date: toTimestamp(endDate),
                reserver: {
                    name: reserverName,
                    email: reserverEmail
                },
                locations: locations,
                classification: 'reservation'
            }

            if (reserverPhone !== undefined && reserverPhone !== '') {
                console.log('phone', reserverPhone)
                updated.reserver.phone_number = reserverPhone;
            }

            updateReservation((reservation.id === 'new') ? undefined : reservation.id, updated);

            setReservation(undefined);
        }      
    }

    return (
        <div id={styles.reservation_editor} className={reservation == undefined ? styles.resit_hidden : ''}>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <h2>Event Details</h2>
                <label htmlFor="res-name">Reservation Name<span style={{color: 'red'}}>*</span></label>
                <input id="res-name" type="text" defaultValue={reservation?.name} onChange={(e) => {setName(e.target.value); notEmpty(e);}}/>

                <div className={styles.datetime_picker}>
                    <label htmlFor="res-start">Event Start Date/Time<span style={{color: 'red'}}>*</span></label>
                    <input id="res-start" type="date" defaultValue={initalStartDate} onChange={(e) => {onStartTimeChanged(e); notEmpty(e);}}/>
                    <input id="res-start-t" type="time" defaultValue={initalStartTime} onChange={(e) => {onStartTimeChanged(e); notEmpty(e);}}/>
                </div>

                <div className={styles.datetime_picker}>
                    <label htmlFor="res-end">Event End Date/Time<span style={{color: 'red'}}>*</span></label>
                    <input id="res-end" type="date" defaultValue={initalEndDate} onChange={(e) => {onEndTimeChanged(e); notEmpty(e);}}/>
                    <input id="res-end-t" type="time" defaultValue={initalEndTime} onChange={(e) => {onEndTimeChanged(e); notEmpty(e);}}/>
                </div>

                <p>Locations</p>
                <LocationsSelector setSelectedLocations={setLocations} selectedLocations={locations}
                    dropdownVisibily={dropDownVisible} setDropdownVisibily={setDropdownVisible}/>
            </div>
            <div id={styles.reserver}>
                <h2>Reserver</h2>
                <label htmlFor="res-rname">Name<span style={{color: 'red'}}>*</span></label>
                <input id="res-rname" type="text" defaultValue={reservation?.reserver?.name} onChange={(e) => {setReserverName(e.target.value); notEmpty(e);}}/>
                <label htmlFor="res-remail">Email<span style={{color: 'red'}}>*</span></label>
                <input id="res-remail" type="text" defaultValue={reservation?.reserver?.email} onChange={(e) => {setReserverEmail(e.target.value); notEmpty(e);}}/>
                <label htmlFor="res-rphone">Phone Number</label>
                <PhoneNumberInput id='res-rphone' phoneNumber={reserverPhone} setPhoneNumber={setReserverPhone}/>

                <div id={styles.buttons}>
                    <button onClick={() => onSave()}>{reservation === true ? 'Create Reservation' : 'Save Edit'}</button>
                    <button onClick={() => setReservation(undefined)}>Cancel</button>
                </div>
            </div>
        </div>
    );
}